import { Component, Input } from "@angular/core";
import { MemorialService } from "administrativo-lib";
import { BaseResourceRptComponent, Coluna, CpfPipe, Favorecido, Licitacao, LicitacaoPipe, Memorial } from "eddydata-lib";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: 'app-mapa-preco-rpt',
  templateUrl: './mapa-preco-rpt.component.html'
})
export class MapaPrecoRptComponent extends BaseResourceRptComponent {

  @Input() public licitacao: Licitacao;
  private empresas: { indice: number, favorecido: Favorecido }[] = [];
  private modelo: 'SEM_AGRUPAMENTO' | 'COM_AGRUPAMENTO' | 'LISTA' = 'SEM_AGRUPAMENTO';

  constructor(
    private memorialService: MemorialService
  ) {
    super();
  }

  protected afterInit(): void {
  }

  protected tituloRelatorio(): string {
    return `Mapa de Preços - ${new LicitacaoPipe().transform(this.licitacao.numero)}`;
  }

  protected obterColunasRelatorio(): Coluna[] {
    const retorno: Coluna[] = [];

    if (this.modelo === 'SEM_AGRUPAMENTO') {
      retorno.push({ titulo: 'Item', coluna: 'item' });
    } else {
      retorno.push({ titulo: 'Item:', coluna: 'item', bold: true, agrupar: true });
    }

    this.empresas.forEach(f => {
      retorno.push({ titulo: `Empresa ${f.indice}`, coluna: `valor${f.indice}`, decimais: 4, alignment: 'right' });
    });

    return retorno;
  }

  protected larguraColunas(): (string | number)[] {
    const colunas: string[] = [];

    if (this.modelo === 'SEM_AGRUPAMENTO') {
      colunas.push('*')
    }

    this.empresas.forEach(f => colunas.push('auto'));
    return colunas;
  }

  protected totalizarColunas(): (string | {})[] {
    return undefined;
  }

  protected carregarLista(): Promise<any[]> {
    return new Promise((resolve) => {
      const lista: any[] = [];
      this.memorialService.obterPorLicitacao(this.licitacao.id, true).pipe(takeUntil(this.unsubscribe))
        .subscribe(async (res) => {
          const reg: Memorial[] = res.content;

          let favorecidos: Favorecido[] = [];
          this.empresas = [];
          await new Promise((resolve2) => {
            reg.forEach(m => m.propostas.forEach(p => favorecidos.push(p.proponente.favorecido)));
            favorecidos = favorecidos.filter((fav, idx, self) => idx === self.findIndex((f) => f.id === fav.id));

            resolve2(true);
          }).then(() => {
            for (let i = 0; i < favorecidos.length; i++) {
              this.empresas.push({ indice: i + 1, favorecido: favorecidos[i] });
            }

            if (this.orientacao === 'portrait') {
              if (this.empresas.length <= 5) {
                this.modelo = 'SEM_AGRUPAMENTO';
              } else if (this.empresas.length <= 10) {
                this.modelo = 'COM_AGRUPAMENTO';
              } else {
                this.modelo = 'LISTA';
              }
            } else {
              if (this.empresas.length <= 10) {
                this.modelo = 'SEM_AGRUPAMENTO';
              } else if (this.empresas.length <= 15) {
                this.modelo = 'COM_AGRUPAMENTO';
              } else {
                this.modelo = 'LISTA';
              }
            }

            reg.forEach(memorial => {
              const mapa = {};
              mapa['item'] = `${memorial.ordem} - ${memorial.descricao} ${memorial.unidade} - ${memorial.quantidade}x`;
              this.empresas.forEach(f => {
                mapa[`valor${f.indice}`] = +memorial.propostas.find(p => p.proponente.favorecido.id === f.favorecido.id)?.valor_unitario;
              })
              lista.push(mapa);
            });

            resolve(lista);
          });
        });
    })
  }

  protected conteudoAdicional(): {}[] {
    const retorno = [];
    retorno.push({ text: 'Legenda das Empresas:', bold: true, alignment: 'left', fontSize: 10, margin: [0, 10, 0, 5] });
    this.empresas.forEach(f => {
      retorno.push({ text: `· Empresa ${f.indice}: ${new CpfPipe().transform(f.favorecido.cpf_cnpj)} - ${f.favorecido.nome}`, margin: [5, 0, 0, 0] });
    });
    return retorno;
  }
}